export const FETCH_QUERY_USERS_REQUEST = "USERS/FETCH_QUERY_REQUEST";
export const FETCH_QUERY_USERS_SUCCESS = "USERS/FETCH_QUERY_SUCCESS";
export const FETCH_QUERY_USERS_FAILURE = "USERS/FETCH_QUERY_FAILURE";
